<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item style="font-size: 1vw;">物料申请入库配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="content-container">
      是否开启：
      <el-select v-model="isOpen" @change="changeState">
        <el-option label="开启" value="1"></el-option>
        <el-option label="不开启" value="0"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  export default {
    data() {
      return {
        projectId: '',
        isOpen: ''  
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      getData(){
        myHttp.findProjectPurchaseConfig({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            this.isOpen = resp.data.data.config.isOpen
          }else{
            this.$message({
              type: 'error',
              showClose: true,
              message: resp.data.msg
            })
          }
        })
      },
      changeState(){
        myHttp.configProjectPurchase({
          projectId: this.projectId,
          isOpen: this.isOpen
        }).then(resp => {
          if(resp.data.code === 200){
              this.$message({
              type: 'success',
              showClose: true,
              message: '配置成功！！'
            })
          }else{
            this.$message({
              type: 'error',
              showClose: true,
              message: resp.data.msg
            })
          }
        })
      }
    },
  }
</script>

<style scoped>
.content{
  background-color: #fff;
}
.content-container{
  padding: 2vh 1vw;
  text-align: left;
}
</style>